/* eslint-disable camelcase */

import PropTypes from 'prop-types';
import React from 'react';

import Category from '../Category';
import CategoryType from '../../types/Category';
import {
  isFulfilledCategory,
  isMaxSelectedCategory,
  numItemsToMaxInCategory,
} from '../../utils/addOnsHelpers';

class Menu extends React.Component {
  static propTypes = {
    clearCategory: PropTypes.func,
    currencyCode: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        category_id: PropTypes.number,
        item_id: PropTypes.number,
        quantity: PropTypes.number,
      })
    ).isRequired,
    menu: PropTypes.shape({
      option_groups: PropTypes.arrayOf(CategoryType),
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    seats: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    sourceId: PropTypes.string,
  }

  static defaultProps = {
    clearCategory: undefined,
    currencyCode: 'USD',
    seats: undefined,
    sourceId: undefined,
  }

  getCategoryProps = (category) => {
    const {
      clearCategory, currencyCode, items, onChange, seats, sourceId,
    } = this.props;

    return {
      ...category,
      clearCategory,
      currencyCode,
      fulfilled: isFulfilledCategory(category, items, seats),
      items,
      maxSelected: isMaxSelectedCategory(category, items, seats),
      numItemsToMax: numItemsToMaxInCategory(category, items, seats),
      onChange,
      seats,
      sourceId,
    };
  }

  renderCategories = () => {
    const {
      menu: {
        option_groups: categories,
      } = {},
    } = this.props;
    return categories.map((category) => <Category key={category.option_group_id} {...this.getCategoryProps(category)} />);
  }

  render() {
    return (
      <div className="Menu">
        {this.renderCategories()}
      </div>
    );
  }
}

export default Menu;
